import * as Types from '../../../__generated__/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeletePageChoiceMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type DeletePageChoiceMutation = { __typename?: 'RootMutationType', deletePageChoice?: { __typename?: 'ActionResult', userErrors?: Array<{ __typename?: 'UserError', field: string, message: string }> | null } | null };


export const DeletePageChoiceDocument = gql`
    mutation deletePageChoice($id: ID!) {
  deletePageChoice(id: $id) {
    userErrors {
      field
      message
    }
  }
}
    `;
export type DeletePageChoiceMutationFn = Apollo.MutationFunction<DeletePageChoiceMutation, DeletePageChoiceMutationVariables>;

/**
 * __useDeletePageChoiceMutation__
 *
 * To run a mutation, you first call `useDeletePageChoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePageChoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePageChoiceMutation, { data, loading, error }] = useDeletePageChoiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePageChoiceMutation(baseOptions?: Apollo.MutationHookOptions<DeletePageChoiceMutation, DeletePageChoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePageChoiceMutation, DeletePageChoiceMutationVariables>(DeletePageChoiceDocument, options);
      }
export type DeletePageChoiceMutationHookResult = ReturnType<typeof useDeletePageChoiceMutation>;
export type DeletePageChoiceMutationResult = Apollo.MutationResult<DeletePageChoiceMutation>;
export type DeletePageChoiceMutationOptions = Apollo.BaseMutationOptions<DeletePageChoiceMutation, DeletePageChoiceMutationVariables>;